import React from "react";
import "./About.css"
const About = () => {
	return (
		<section className="about indigo darken-5 ">
			<div className="email-subscription container center">
				<div className="subscribe">
					<h1 className="text-white">Newsletter</h1>
					<input type="" placeholder="Enter your email" />
					<button>Subscribe</button>
				</div>
			</div>
		</section>
	);
};

export default About;
